import React, { Fragment } from 'react';

import { Grid } from '@mui/material';
import useTransformStore from '../../useTransformStore';
import ChipInput from '../../../ChipInput/ChipInput';

function CountLength({ onPlaceholderSelected, availablePlaceholders, followList, index }) {
  return (
    <Fragment>
      <Grid item xs={12} className="item-label">
        Count the length of the following list
      </Grid>
      <Grid item xs={12} className="input-list-transform">
        <ChipInput
          onPlaceholderSelected={onPlaceholderSelected}
          placeholders={availablePlaceholders}
          fullWidth
          onBeforeAdd={chip => {
            useTransformStore.getState().setComponent(chip, index, 'followList');
            return true;
          }}
          placeholder="Insert a list"
          inputValue={followList}
          onDelete={indexChip => useTransformStore.getState().deleteChip(indexChip, index, 'followList')}
          onFocus={() => useTransformStore.getState().setFocus(index, 'followList')}
        />
      </Grid>
    </Fragment>
  );
}

export default CountLength;
